<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="padding-bottom: 50px;">
    <div class="row" style="padding-top: 0px;margin-top: -10px;">
      <div class="dashboard-user d-flex  gap-5 justify-content-between" v-if="checkEmptyUser">
        <div class=" col-sm-4 d-flex flex-column gap-2">
          <img :src="user.image_url" class="dashboard-user-img" alt="name" width="60" height="60">
<!--          <div class="user-position">{{ user.level }}</div>-->
          <div class=" dashboard-user-name">{{ $t('HEY') }},{{ user.name }}</div>
        </div>
        <div class="col-sm-2 dashboard-atom-img ">
          <!-- <img src="@/assets/img/happy_img/atom_happy.png" alt="wallet-coin" width="" height=""> -->
          <img src="@/assets/img/quizgiri-logo.png" alt="wallet-coin" width="" height="">
        </div>
      </div>
    </div>

    <div class="row mt-2" v-if="showDailyTournament">
      <div class="col-lg-12">
        <div class="running-tournament-title">{{ $t('DAILY_TOURNAMENTS') }}</div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <carousel :settings="settings" :breakpoints="breakpoints">
            <slide v-for="(tournament) in dailyTournaments" :key="tournament.id"
                   :style="{'background-image': `url(${tournament.img_background})`}">

              <router-link :to="{ path: '/tournament-details', query: { tournament_id: tournament.id }}">
                <div class="tournament-card d-flex flex-column">
                  <div class="tournament-content d-flex justify-content-between">
                    <div class="d-flex flex-column">

                      <div class="tournament-time-left">
                        <img src="@/assets/img/happy_img/clock.png" width="10" height="10" :alt="tournament.name">
                        {{ tournament.time_left }}
                      </div>
                      <div class="default-img" style="margin-top:-10px;">
                        <img :src="tournament.tournament_image" width="100" height="100" alt="default">
                      </div>
                    </div>
                    <div class="d-lex flex-column justify-content-between">
                      <div class="tournament-title">{{ tournament.name }}</div>
                      <div class="tournament-prize" style="margin-top: -7px;">
                        <span style="padding-top: -7px;"> {{ tournament.prize }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </slide>
            <template #addons>
            </template>
          </carousel>
        </div>
      </div>
    </div>

    <div class="row mt-4" v-if="showMegaTournament">
      <div class="col-lg-12">
        <div class="running-tournament-title">{{ $t('MEGA_TOURNAMENTS') }}</div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <carousel :settings="settings" :breakpoints="breakpoints">
            <slide v-for="(tournament) in megaTournaments.slice().reverse()" :key="tournament.id"
                   :style="{'background-image': `url(${tournament.img_background})`}">

              <router-link :to="{ path: '/tournament-details', query: { tournament_id: tournament.id }}">
                <div class="tournament-card d-flex flex-column">
                  <div class="tournament-content d-flex justify-content-between">
                    <div class="d-flex flex-column">

                      <div class="tournament-time-left">
                        <img src="@/assets/img/happy_img/clock.png" width="10" height="10" :alt="tournament.name">
                        {{ tournament.time_left }}
                      </div>
                      <div class="default-img" style="margin-top:-10px;">
                        <img :src="tournament.tournament_image" width="100" height="100" alt="default">
                      </div>
                    </div>
                    <div class="d-lex flex-column justify-content-between">
                      <div class="tournament-title">{{ tournament.name }}</div>


                      <div class="tournament-prize" style="margin-top: -7px;">
                        <span style="padding-top: -7px;"> {{ tournament.prize }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>

            </slide>

            <template #addons>

            </template>
          </carousel>
        </div>
      </div>
    </div>

    <div class="row mt-4" v-if="showTopics">
      <div class="col-lg-12 d-flex justify-content-between align-items-center mt-2 mb-2">
        <div class="top-topic-title">{{ $t('CATEGORIES') }}</div>
      </div>
    </div>

    <div class="row" v-if="showTopics">
      <div class="col-lg-12">
        <div class="row mb-4">
          <carousel :settings="settings" :breakpoints="breakpoints">
            <slide v-for="topic in topics" :key="topic.topic_id" class="topic-card col-lg-3" >
              <router-link :to="{ path: '/topic-details', query: {
              topic_id: topic.topic_id,
              topic: 'Top Topics',
              category_name: topic.category_name
            } }">
                <div class=" d-flex flex-column justify-content-center align-items-center">
                  <img class="topic-img" :src="topic.image_url" :alt="topic.name" height="150" width="150"/>
                  <div class="topic-title"> {{ topic.name }}</div>
                </div>
              </router-link>
            </slide>
            <template #addons>
            </template>
          </carousel>
        </div>
      </div>
    </div>

    <DashboardFooterMenu/>
    <CoinModal :modal-show="showCoinModal" v-if="showCoinModal"/>
  </div>
</template>
<script>
import {sendRequest} from '@/http/axios.method';
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import _ from "lodash";
import CoinModal from "@/views/components/CoinModal";
import DashboardFooterMenu from "@/views/components/DashboardFooterMenu";
import level from '@/assets/img/happy_img/P.png';
import 'vue3-carousel/dist/carousel.css';
import {Carousel, Slide} from 'vue3-carousel';


export default {
  name: "dashboard",
  components: {
    Loader,
    CoinModal,
    DashboardFooterMenu,
    Carousel,
    Slide,

  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      user: [],
      wallet: [],
      dailyTournaments: [],
      showDailyTournament: false,
      megaTournaments: [],
      showMegaTournament: false,
      topics: [],
      showTopics: false,
      showCoinModal: false,
      level: level,
      settings: {
        itemsToShow: 1,
        snapAlign: "start"
      },
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center"
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start"
        }
      }
    };
  },
  created() {
    this.getUser();
    this.getDailyTournament();
    this.getMegaTournament();
    this.getTopic();
    this.emitter.on('coin-modal-close-event', (evt) => {
      this.showCoinModal = evt.eventContent;
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },

    getUser() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/user', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.user = response.data;
              this.wallet = this.user.wallet;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getDailyTournament() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/tournament/daily', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.dailyTournaments = response.data.tournaments;
              if (!_.isEmpty(this.dailyTournaments)) {
                let image_number = 1;
                this.dailyTournaments.forEach(tournament => {
                  let current_image = tournament.tournament_image.replace(process.env.VUE_APP_AWS_IMAGE_PATH, '');
                  tournament.tournament_image = ! _.isEmpty(current_image)? tournament.tournament_image : require('@/assets/img/happy_img/default_pic.png');
                  let current_image_number = image_number;
                  tournament.img_background = require('@/assets/img/happy_img/daily_' + image_number + '.png');
                  image_number = image_number > 3 ? 1 : ++current_image_number;
                });
                this.showDailyTournament = true;
              }
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getMegaTournament() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/tournament/mega', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.megaTournaments = response.data.tournaments;
              if (!_.isEmpty(this.megaTournaments)) {
                let image_number = 1;
                this.megaTournaments.forEach(tournament => {
                  let current_image = tournament.tournament_image.replace(process.env.VUE_APP_AWS_IMAGE_PATH, '');
                  tournament.tournament_image = ! _.isEmpty(current_image)? tournament.tournament_image : require('@/assets/img/happy_img/default_pic.png');
                  let current_image_number = image_number;
                  tournament.img_background = require('@/assets/img/happy_img/mega_' + image_number + '.png');
                  image_number = image_number > 3 ? 1 : ++current_image_number;
                });
                this.showMegaTournament = true;
              }

            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getTopic() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/topics', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.topics = response.data.topics;
              if (!_.isEmpty(this.topics)) {
                this.showTopics = true;
              }
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  },

  computed: {
    checkEmptyUser() {
      return !_.isEmpty(this.user);
    }
  }
};
</script>

<style scoped>
.carousel__item {
}

.carousel__slide {
  max-width: 300px;
  margin-left: 15px;
  border-radius: 8px;
}

.carousel__prev,
.carousel__next {
}

.carousel__slide--visible {
  transform: rotateY(0);
}
</style>
